import "./css/question.css"
const QuestionCard = ({ children }) => {
  return <div className="question-card">{children}</div>;
};

export default QuestionCard;
